export let hrms16xColumns = () => {
  let indexColumns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRMS16XC1',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRMS16XC1',
      labelIndex: '70',
      style: 'min-width: 200px;'
    }, {
      key: 'kpino',
      name: '',
      labelCodapp: 'HRMS16XC1',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'kpiitem',
      name: '',
      labelCodapp: 'HRMS16XC1',
      labelIndex: '90',
      style: 'min-width: 200px;'
    }, {
      key: 'target',
      name: '',
      labelCodapp: 'HRMS16XC1',
      labelIndex: '100',
      style: 'min-width: 200px;'
    }, {
      key: 'dteapkpi',
      name: '',
      labelCodapp: 'HRMS16XC1',
      labelIndex: '110',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'actbedon',
      name: '',
      labelCodapp: 'HRMS16XC1',
      labelIndex: '120',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_mtrunit',
      name: '',
      labelCodapp: 'HRMS16XC1',
      labelIndex: '130',
      style: 'min-width: 100px;'
    }, {
      key: 'mtrvalue',
      name: '',
      labelCodapp: 'HRMS16XC1',
      labelIndex: '140',
      class: 'align-right',
      style: 'min-width: 100px;'
    }, {
      key: 'mtrvalnet',
      name: '',
      labelCodapp: 'HRMS16XC1',
      labelIndex: '150',
      class: 'align-right',
      style: 'min-width: 100px;'
    }
  ]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrms16x.js